import { render } from "./HeroSettingNotification.vue?vue&type=template&id=af789f84&scoped=true"
import script from "./HeroSettingNotification.vue?vue&type=script&lang=js"
export * from "./HeroSettingNotification.vue?vue&type=script&lang=js"

import "./HeroSettingNotification.vue?vue&type=style&index=0&id=af789f84&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af789f84"]])

export default __exports__